'use strict';

angular.module('far.committee')
    .controller('CommitteeIndexController', function ($log, $http) {
        var vm = {
            progress: false,
            construct: function (committee) {
                vm.form = { id: committee };
            }
        };

        return vm;
    });